import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {AuthGuard} from "../../shared-module/seguridad/services/auth.guard";
import {HomeHorasExtrasComponent} from "./views/home-horas-extras/home-horas-extras.component";
import {ParametrizacionFeriadosComponent} from "./views/parametrizacion-feriados/parametrizacion-feriados.component";
import {
  ParametrizacionPorcentajeRecargaComponent
} from "./views/parametrizacion-porcentaje-recarga/parametrizacion-porcentaje-recarga.component";
import {ParametrizacionEmpleadosComponent} from "./views/parametrizacion-empleados/parametrizacion-empleados.component";
import {
  ParametrizacionFechaCorteComponent
} from "./views/parametrizacion-fecha-corte/parametrizacion-fecha-corte.component";
import {HorasExtraCargaTurnosComponent} from "./views/horas-extra-carga-turnos/horas-extra-carga-turnos.component";
import {ModificacionMarcacionesComponent} from "./views/modificacion-marcaciones/modificacion-marcaciones.component";
import {
  VerificacionTalentoHumanoComponent
} from "./views/verificacion-talento-humano/verificacion-talento-humano.component";
import {
  ModificacionMarcacionesRecursosHumanosComponent
} from "./views/modificacion-marcaciones-recursos-humanos/modificacion-marcaciones-recursos-humanos.component";
import {
  VerificacionTalentoHumanoRecursosHumanosComponent
} from "./views/verificacion-talento-humano-recursos-humanos/verificacion-talento-humano-recursos-humanos.component";
import {
  VerificacionTalentoHumanoRecursosHumanosCalculadoComponent
} from "./views/verificacion-talento-humano-recursos-humanos-calculado/verificacion-talento-humano-recursos-humanos-calculado.component";
import {
  ParametrizacionMinutosGraciaComponent
} from "./views/parametrizacion-minutos-gracia/parametrizacion-minutos-gracia.component";
import {
  ParametrizacionLocalidadesTurnosComponent
} from "./views/parametrizacion-localidades-turnos/parametrizacion-localidades-turnos.component";
import {
  ParametrizacionReemplazoEmpleadosComponent
} from "./views/parametrizacion-reemplazo-empleados/parametrizacion-reemplazo-empleados.component";
import {
  VerificacionTalentoHumanoSegundaValidacionComponent
} from "./views/verificacion-talento-humano-segunda-validacion/verificacion-talento-humano-segunda-validacion.component";
import {
  ParametrizacionTipoTurnoComponent
} from "./views/parametrizacion-tipo-turno/parametrizacion-tipo-turno.component";
import {
  ReplicaMarcacionEmpleadoComponent
} from "./views/replica-marcacion-empleado/replica-marcacion-empleado.component";
import {
  ReplicaMarcacionDepartamentoComponent
} from "./views/replica-marcacion-departamento/replica-marcacion-departamento.component";


const horasextrasRoutes: Routes = [
  //* SIN ROLES
  {path: 'horas-extras/home', component: HomeHorasExtrasComponent, canActivate: [AuthGuard]},
  {
    path: 'horas-extras/parametrizacion/feriados',
    component: ParametrizacionFeriadosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/parametrizacion/porcentaje-recarga',
    component: ParametrizacionPorcentajeRecargaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/parametrizacion/empleado',
    component: ParametrizacionEmpleadosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/parametrizacion/fecha-corte',
    component: ParametrizacionFechaCorteComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/cargar-turno',
    component: HorasExtraCargaTurnosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/cargar-turno/rrhh',
    component: HorasExtraCargaTurnosComponent,
    data: {
      rrhh: true
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/modificacion-marcaciones',
    component: ModificacionMarcacionesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/modificacion-marcaciones-recursos-humanos',
    component: ModificacionMarcacionesRecursosHumanosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/verificacion-talento-humano',
    component: VerificacionTalentoHumanoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/verificacion-talento-humano-recursos-humanos',
    component: VerificacionTalentoHumanoRecursosHumanosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/verificacion-talento-humano-recursos-humanos-calculados',
    component: VerificacionTalentoHumanoRecursosHumanosCalculadoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/parametrizacion/minutos-gracia',
    component: ParametrizacionMinutosGraciaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/parametrizacion/localidades-turnos',
    component: ParametrizacionLocalidadesTurnosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/parametrizacion/reemplazo-empleados',
    component: ParametrizacionReemplazoEmpleadosComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/verificacion-talento-humano-segunda-validacion',
    component: VerificacionTalentoHumanoSegundaValidacionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/parametrizacion/tipo-turno',
    component: ParametrizacionTipoTurnoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/modificacion-marcaciones-empleado',
    component: ReplicaMarcacionEmpleadoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'horas-extras/modificacion-marcaciones-departamento',
    component: ReplicaMarcacionDepartamentoComponent,
    canActivate: [AuthGuard]
  },
  //*ADMINISTRADOR
  /*  { path: 'horas-extras/administrador/mantenedor-gerencias', component: FrmMantenedorGerenciaComponent, canActivate: [AdminPortalComprasGuard] },*/
];

@NgModule({
  imports: [RouterModule.forChild(horasextrasRoutes)],
  exports: [RouterModule]
})
export class HorasExtrasRoutingModule {
}
